<template>
  <div>
    <div class="page-title">{{activityTitle}}</div>

    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <div class="card-content-lsy" v-for="(item, index) in list" :key="index">
        <div class="card-inner mt15">
          <div>
            <div class="title">{{item.customerName}}</div>
            <div class="desc">
              <span>{{item.customerPhone}}</span>
              <a :href="'tel:' + item.customerPhone" ref="telPhone">
                <img class="desc-right" src="@/assets/icons/icon_phone.png" alt="">
              </a>
            </div>
          </div>
          <div class="card-right">
            <!-- <van-icon name="arrow-up" /> -->
          </div>
        </div>
        <div class="card-inner list-item">
          <div class="card-text">分享职员</div>
          <div class="card-text">{{item.h5UserName}}</div>
        </div>
        <div class="card-inner list-item">
          <div class="card-text">分享门店</div>
          <div class="card-text">{{item.storeName}}</div>
        </div>
        <div class="card-inner list-item">
          <div class="card-text">状态</div>
          <div class="card-text">{{item.status|status}}</div>
        </div>
        <div class="card-inner list-item">
          <div class="card-text">标签</div>
          <div class="card-text">
            <van-popover
              v-model="item.showPopover"
              theme="dark"
              trigger="click"
              :actions="actions"
              placement="bottom-end"
              @select="action => changeTag(action, item)"
            >
              <template #reference>
                {{item.customerTag|formatSignupTag}}
              </template>
            </van-popover>
          </div>
        </div>
      </div>
    </refresh-list>

    
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
import { decode } from '@/utils/encryption'
import { mapGetters } from 'vuex'
export default {
  components: {
    refreshList
  },
  data() {
    return {
      showPopover: false,
      actions: [
        { text: '已进店', value: 1 }, 
        { text: '未进店', value: 2  }, 
        { text: '已成交', value: 3  }, 
        { text: '已流失', value: 4  }
      ],
      list: [],
      pageNum: 1,
      pageSize: 20,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isTeacher',
    ]),
    activityId() {
      return this.$route.query.activityId
    },
    activityTitle() {
      return this.$route.query.activityTitle
    },
    customerId() {
      return this.$route.query.customerId
    },
    customerName() {
      return this.$route.query.customerName
    },
    storeCode() {
      return this.$route.query.storeCode
    },
    storeName() {
      return this.$route.query.storeName
    },
    userId() {
      return this.$route.query.userId
    },
    userName() {
      return this.$route.query.userName
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        filterData: {
          activityId: this.activityId,
          enterPrimaryKey: this.$route.query.enterPrimaryKey,
          enterType: this.$route.query.enterType,
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.h5.queryAppUserActivityStatisticList(data)
      .then(res=>{
        if(res.code == 200) {
          const list = res.data.list.map(item => ({
            ...item,
            customerPhone: !this.isTeacher ? decode(item.customerPhone) : item.customerPhone,
            showPopover: false
          }))
          this.list.push(...list);
          this.pageNum = res.data.pageNum + 1;
          this.$refs['refreshList'].complete(res.data);
        }else{
          this.$refs['refreshList'].onFinish();
        }
      })
      .catch(err=>{
        this.$refs['refreshList'].onFinish();
      })
    },
    changeTag(action, item) {
      this.$api.h5.updateCustomerTag(item.joinLogId,action.value,item.sourceType).then(() => {
        item.customerTag = action.value;
      });
    }
  },
  filters: {
    status(state) {
      let map = {
        1: "已报名(报名)",
        2: "已核销(报名)",
        3: "已退款(报名)",
        4: "退款中(报名)",
        11: "待兑奖(抽奖)",
        12: "已兑奖(抽奖)",
        13: "发放异常(抽奖)",
        14: "未兑奖已过期(抽奖)",
        21: "已支付待核销(秒杀)",
        22: "已核销(秒杀)"
      };
      return map[state];
    },
    formatSignupTag(val) {
      if(val == 1) {
        return '已进店'
      }else if(val == 2) {
        return '未进店'
      }else if(val == 3) {
        return '已成交'
      }else if(val == 4) {
        return '已流失'
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .crumbs
    display block
    position relative
    margin 15px
    line-height 1.4
    span
      font-size 14px
      display inline
      position relative
    span:not(:last-child)
      &::after
        position absolute
        content "/"
        right -10px
        color #999
    span+span
      margin-left 18px
    .gray
      color #999
  
  .list-item
    height 40px
    border-bottom 1px solid #eee
    margin 0 15px
    // padding 10px 0
    .card-text:first-child
      color #999
    .card-text:nth-child(2)
      text-align right
  
  .card-content-lsy
    .card-inner
      margin 0 15px
  .mt15
    margin-top 15px !important
  
  .title
    font-size 16px
    color #333
    margin-bottom 5px
  .desc
    display flex
    justify-content: space-between
    align-items: center
    color #999
    width 318px
    .desc-right 
      width 32px
      height 32px
  .page-title
    font-size 16px
    font-weight bold
    color #333333
    margin 10px 15px 0
</style>